import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";
import {defaultError, WebError} from "@hybird/core/error";
import {flutterCore, permissions} from "@hybird/flutter/bridge/core";
import {deviceError} from "@hybird/device/deviceError";

export class FlutterLocation extends BridgeMethod {

  constructor() {
    super();
  }

  async requestPermissionLocation() {
    return invoke("requestPermissionLocation");
  }

  async getLocation() {
    await this.checkLocation();

    return invoke("getLocation");
  }


  // 判断版本
  compareVersion(version1, version2) {
    const arr1 = version1.split('.')
    const arr2 = version2.split('.')
    const length1 = arr1.length
    const length2 = arr2.length
    const minlength = Math.min(length1, length2)
    let i = 0
    for (i; i < minlength; i++) {
      let a = parseInt(arr1[i])
      let b = parseInt(arr2[i])
      if (a > b) {
        return 1
      } else if (a < b) {
        return -1
      }
    }
    if (length1 > length2) {
      for (let j = i; j < length1; j++) {
        if (parseInt(arr1[j]) != 0) {
          return 1
        }
      }
      return 0
    } else if (length1 < length2) {
      for (let j = i; j < length2; j++) {
        if (parseInt(arr2[j]) != 0) {
          return -1
        }
      }
      return 0
    }
    return 0
  }

  async checkLocation() {
    const flag = await flutterCore.requestPermission([permissions.location, permissions.locationWhenInUse]);

    if (!flag.isGranted) {
      if (!flag.granted.includes(permissions.locationWhenInUse)) {
        if (flag.denied.includes(permissions.location)) {
          throw WebError.code(defaultError.NOT_PERMISSION, {
            msg: "位置权限未授权, 请前往设置授权",
            data: [permissions.location]
          })
        } else if (flag.denied.includes(permissions.locationWhenInUse)) {
          throw WebError.code(defaultError.NOT_PERMISSION, {
            msg: "位置权限请选择使用App期间, 请前往设置授权",
            data: [permissions.location]
          })
        }
      }
    }

    const deviceInfo = await flutterCore.deviceInfo();

    if (this.compareVersion(deviceInfo.app.version, "3.10.6") <= 0) {
      return true;
    }

    const checkLocation = await invoke("checkLocation");

    if (!checkLocation) {
      throw WebError.code(deviceError.LOCATION_PERMISSION_NOT_OPEN)
    }

    return true;
  }

  async onLocationChange(callback) {
    await this.checkLocation();

    await on("onLocationChange", callback, {isSend: true});

    return callback;
  }

  async offLocationChange(callback) {
    return cancel("onLocationChange", {event: callback, isSend: true});
  }
}

export const flutterLocation = new FlutterLocation();